export default [
  {
    title: "공통분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "공통분야",
        content: "1. 이력카드의 구비 및 기록여부(소방계획서)",
        isChecked: "",
      },
      {
        id: 2,
        title: "공통분야",
        content: "2. 안전관리자 선임여부 및 부재시 대응방안 수립 여부",
        isChecked: "",
      },
      {
        id: 3,
        title: "공통분야",
        content: "3. 긴급재난시 대피지침 수립여부",
        isChecked: "",
      },
      {
        id: 4,
        title: "공통분야",
        content: "4. 비상연락망 구비여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "건축분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "주요시설",
        content: "1. 보의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        id: 2,
        title: "주요시설",
        content: "2. 기둥(내력벽 등)의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        id: 3,
        title: "주요시설",
        content: "3. 슬래브(바닥판)의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        id: 4,
        title: "주요시설",
        content: "4. 주계단의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        id: 5,
        title: "주요시설",
        content: "5. 벽체의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        id: 6,
        title: "주요시설",
        content: "6. 지반 침하 및 이로 인한 활동적인 균열",
        isChecked: "",
      },
      {
        id: 7,
        title: "주요시설",
        content: "7. 누수, 부식 등에 의한 구조물의 기능 상실",
        isChecked: "",
      },
      {
        id: 8,
        title: "주요시설",
        content: "8. 주요강재의 변형 및 접합부 상태",
        isChecked: "",
      },
      {
        id: 9,
        title: "일반시설",
        content: "9. 지붕(옥상)의 균열 및 상태",
        isChecked: "",
      },
      {
        id: 10,
        title: "일반시설",
        content: "10. 계단실(복도)의 균열 및 상태",
        isChecked: "",
      },
      {
        id: 11,
        title: "일반시설",
        content: "11. 외벽타일 또는 석재의 균열 및 탈락상태",
        isChecked: "",
      },
      {
        id: 12,
        title: "일반시설",
        content: "12. 시설 외부 또는 내부의 과하중(물탱크 등) 여부",
        isChecked: "",
      },
      {
        id: 13,
        title: "일반시설",
        content: "13. 강재의 도장 및 관리상태",
        isChecked: "",
      },
      {
        id: 14,
        title: "부대시설 - 일반",
        content: "14. 옹벽, 석축 및 담장의 균열 및 상태",
        isChecked: "",
      },
      {
        id: 15,
        title: "부대시설 - 일반",
        content: "15. 마감재(광고판 등)의 돌출 및 위험요소(충돌, 안전사고) 여부",
        isChecked: "",
      },
      {
        id: 16,
        title: "부대시설 - 일반",
        content: "16. 상 하수도주변 시설 파손 및 누수",
        isChecked: "",
      },
      {
        id: 17,
        title: "부대시설 - 공사장",
        content: "17. 대형건설기계(타워크레인 등) 안전성 및 관리상태",
        isChecked: "",
      },
      {
        id: 18,
        title: "부대시설 - 공사장",
        content: "18. 안전망 등의 설치여부 및 상태",
        isChecked: "",
      },
      {
        id: 19,
        title: "부대시설 - 공사장",
        content: "19. 공사용 안전 가시설 등의 설치여부 및 상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "전기분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "인입구 배선(육안으로 점검할 것)",
        content: "1. 규격 전선의 사용 여부",
        isChecked: "",
      },
      {
        id: 2,
        title: "인입구 배선(육안으로 점검할 것)",
        content: "2. 전선 접속 상태",
        isChecked: "",
      },
      {
        id: 3,
        title: "인입구 배선(육안으로 점검할 것)",
        content: "3. 전선 피복의 손상 여부",
        isChecked: "",
      },
      {
        id: 4,
        title: "인입구 배선(육안으로 점검할 것)",
        content: "4. 배선공사 방법의 적합 여부",
        isChecked: "",
      },
      {
        id: 5,
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "5. 규격전선의 사용 여부",
        isChecked: "",
      },
      {
        id: 6,
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "6. 전선 피복의 손상 여부",
        isChecked: "",
      },
      {
        id: 7,
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "7. 배선공사 방법의 적합 여부",
        isChecked: "",
      },
      {
        id: 8,
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "8. 비닐 코드선 사용 및 문어발 배선 사용 여부",
        isChecked: "",
      },
      {
        id: 9,
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "9. 보행로 전선 노출여부",
        isChecked: "",
      },
      {
        id: 10,
        title: "누전차단기",
        content: "10. 누전차단기 적정 설치 및 정상 작동 여부",
        isChecked: "",
      },
      {
        id: 11,
        title: "누전차단기",
        content: "11. 열화 및 손상 여부",
        isChecked: "",
      },
      {
        id: 12,
        title: "개폐기(차단기를 포함한다)",
        content: "12. 개폐기의 적정설치 및 설치위치의 적합 여부",
        isChecked: "",
      },
      {
        id: 13,
        title: "개폐기(차단기를 포함한다)",
        content: "13. 개폐기의 열화 및 손상 여부",
        isChecked: "",
      },
      {
        id: 14,
        title: "개폐기(차단기를 포함한다)",
        content: "14. 정격퓨즈의 사용 여부",
        isChecked: "",
      },
      {
        id: 15,
        title: "개폐기(차단기를 포함한다)",
        content: "15. 개폐기의 결선 상태",
        isChecked: "",
      },
      {
        id: 16,
        title: "개폐기(차단기를 포함한다)",
        content: "16. 다선식 선로의 각극 개폐장치 여부",
        isChecked: "",
      },
      {
        id: 17,
        title: "비상전원설비",
        content: "17. 정전시 비상전원확보(비상발전기, UPS) 및 정상운전 여부",
        isChecked: "",
      },
      {
        id: 18,
        title: "배 전 반",
        content: "18. 배전함 커버손상 및 사용하지 않는 콘센트의 밀봉여부",
        isChecked: "",
      },
      {
        id: 19,
        title: "부하설비",
        content: "19. 전기기계기구 금속제 외함 접지 및 접지용 콘센트 사용여부",
        isChecked: "",
      },
      {
        id: 20,
        title: "조명시설",
        content: "20. 조명탑 등 전기시설물 유지관리상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "기계분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "시설영역",
        content: "1. 배관의 파손･누수･누기 및 유지관리 상태",
        isChecked: "",
      },
      {
        id: 2,
        title: "시설영역",
        content: "2. 보일러, 공조시설 및 설비배관 부식 여부",
        isChecked: "",
      },
      {
        id: 3,
        title: "시설영역",
        content: "3. 보일러, 공조시설 환기상태 및 배출기 작동여부",
        isChecked: "",
      },
      {
        id: 4,
        title: "시설영역",
        content: "4. 기계실 모든 자재의 정리 정돈 상태",
        isChecked: "",
      },
      {
        id: 5,
        title: "시설영역",
        content: "5. 지하설비 누수 상태",
        isChecked: "",
      },
      {
        id: 6,
        title: "시설영역",
        content: "6. 급수･급탕･공조시설 관리 및 안전성",
        isChecked: "",
      },
      {
        id: 7,
        title: "시설영역",
        content: "7. 오･폐수처리시설 가동상태",
        isChecked: "",
      },
      {
        id: 8,
        title: "시설영역",
        content: "8. 기계식주차시설･주차타워 등의 안전관리 실태",
        isChecked: "",
      },
      {
        id: 9,
        title: "시설영역",
        content: "9. 화재 등 비상시 승강기의 비상운전 작동상태 여부",
        isChecked: "",
      },
      {
        id: 10,
        title: "시설영역",
        content: "10. 승강기 내･외부 안전표지 부착 확인 등",
        isChecked: "",
      },
    ],
  },
  {
    title: "가스분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "현장안전관리 상태검사",
        content: "1. 가스누출 여부(비누방울 시험법)",
        isChecked: "",
      },
      {
        id: 2,
        title: "현장안전관리 상태검사",
        content: "2. 가스누출 경보기 정상 작동여부",
        isChecked: "",
      },
      {
        id: 3,
        title: "현장안전관리 상태검사",
        content: "3. 중간밸브와 자동차단장치 정상 작동여부",
        isChecked: "",
      },
      {
        id: 4,
        title: "현장안전관리 상태검사",
        content: "4. 노출배관 및 부속물 유지관리 상태",
        isChecked: "",
      },
      {
        id: 5,
        title: "현장안전관리 상태검사",
        content: "5. 철거된 가스시설의 배관 또는 호스 끝 마감 처리 여부",
        isChecked: "",
      },
      {
        id: 6,
        title: "현장안전관리 상태검사",
        content: "6. 호스 T 사용 여부 및 호스 3m 이상 사용여부",
        isChecked: "",
      },
      {
        id: 7,
        title: "시설 유지관리 상태검사",
        content: "7. 저장용기 보관실 설치여부 및 위험물표시(100kg 이하는 차양조치)",
        isChecked: "",
      },
      {
        id: 8,
        title: "시설 유지관리 상태검사",
        content: "8. 보일러실에 보일러 이외의 적치물 보관여부",
        isChecked: "",
      },
      {
        id: 9,
        title: "시설 유지관리 상태검사",
        content: "9. 가스보일러가 전용 보일러실에 설치 되었는지 여부",
        isChecked: "",
      },
      {
        id: 10,
        title: "시설 유지관리 상태검사",
        content: "10. 가스저장탱크 안전거리 유지여부(화기와의 거리 유지)",
        isChecked: "",
      },
    ],
  },
  {
    title: "소방분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "소화기 또는 자동확산 소화기", content: "1. 소화기 구획된 실마다 설치 여부", isChecked: "" },
      { id: 2, title: "소화기 또는 자동확산 소화기", content: "2. 안전핀, 호스, 노즐의 부착 상태 및 노즐의 이물질 여부", isChecked: "" },
      { id: 3, title: "소화기 또는 자동확산 소화기", content: "3. 약제 응고상태 및 압력게이지 지시침 확인", isChecked: "" },
      { id: 4, title: "자동화재 탐지설비", content: "4. 수신반 상태확인(정상 작동 여부)", isChecked: "" },
      { id: 5, title: "자동화재 탐지설비", content: "5. 감지기 정상설치 여부 및 작동 여부", isChecked: "" },
      { id: 6, title: "옥내소화전 및 스프링클러", content: "6. 옥내소화전 내의 관창 및 호스연결 상태확인", isChecked: "" },
      { id: 7, title: "옥내소화전 및 스프링클러", content: "7. 비상벨의 외형상 변형, 손상 상태", isChecked: "" },
      { id: 8, title: "옥내소화전 및 스프링클러", content: "8. 누름버튼 작동 시 음향장치 작동 여부", isChecked: "" },
      { id: 9, title: "옥내소화전 및 스프링클러", content: "9. 전동기 및 펌프의 부식 및 파손 여부", isChecked: "" },
      { id: 10, title: "옥내소화전 및 스프링클러", content: "10. 압력게이지 정상 작동 범위에 위치하는지 여부", isChecked: "" },
      { id: 11, title: "옥내소화전 및 스프링클러", content: "11. 경보장치의 스위치 상태", isChecked: "" },
      { id: 12, title: "옥내소화전 및 스프링클러", content: "12. 헤드의 누수ㆍ변형ㆍ손상ㆍ장애 여부", isChecked: "" },
      { id: 13, title: "옥내소화전 및 스프링클러", content: "13. 각종 밸브 정상위치 여부", isChecked: "" },
      { id: 14, title: "피난유도등(유도등)", content: "14. 주위에 유도등의 식별에 장애가 되는 물건 존재 여부", isChecked: "" },
      { id: 15, title: "피난유도등(유도등)", content: "15. 상용전원 차단시의 점등 여부", isChecked: "" },
      { id: 16, title: "비상조명등", content: "16. 비상전원 내장하는 비상조명등 상용전원 차단시 점등 상태", isChecked: "" },
      { id: 17, title: "비상조명등", content: "17. 비상전원 내장하는 비상조명등의 예비전원 상태 확인", isChecked: "" },
      { id: 18, title: "완강기", content: "18. 기구본체 및 로프의 변형, 손상, 풀어짐, 결합부 및 이음매 상태", isChecked: "" },
      { id: 19, title: "완강기", content: "19. 충분한 탈출개구부의 존재 여부", isChecked: "" },
      { id: 20, title: "완강기", content: "20. 배치상태 양호 여부", isChecked: "" },
      { id: 21, title: "방화문(방화셔터)", content: "21. 화재시 감지기의 작동에 의해 자동으로 닫히는 구조인지 확인", isChecked: "" },
      { id: 22, title: "방화문(방화셔터)", content: "22. 방화셔터 작동 개소 주변 적재물(방해물) 여부", isChecked: "" },
      { id: 23, title: "방화문(방화셔터)", content: "23. 방화문 도어클로저 정상작동 여부", isChecked: "" },
      { id: 24, title: "피난탈출구(비상구)", content: "24. 잠금장치 설치 또는 폐쇄 여부", isChecked: "" },
      { id: 25, title: "피난탈출구(비상구)", content: "25. 피난탈출구의 진입부분 및 피난통로 통행 방해 물품방치 여부", isChecked: "" },
    ],
  },
  {
    title: "집단급식소",
    tableHeaderCheck: [{ text: "적합" }, { text: "부적합" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "1. 설치신고 사항 (법 제88조)",
        content: "· 집단급식소 설치 신고 여부",
        isChecked: "",
      },
      {
        id: 2,
        title: "1. 설치신고 사항 (법 제88조)",
        content: "· 설치변경신고 여부(신고사항 임의변경 등)",
        isChecked: "",
      },

      {
        id: 3,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 조리장 바닥에 배수구가 있는 경우 덮개 설치",
        isChecked: "",
      },
      {
        id: 4,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 조리시설, 세척시설, 폐기물용기 및 손씻는 시설",
        isChecked: "",
      },
      {
        id: 5,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 폐기물용기(오물, 악취 등이 누출되지 않도록 뚜껑이 있는 내수성 재질)",
        isChecked: "",
      },
      {
        id: 6,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 자외선 또는 전기살균소독기를 설치하거나 열탕 세척 소독 시설",
        isChecked: "",
      },
      {
        id: 7,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 충분한 환기 시설(자연 통풍 가능 구조는 제외)",
        isChecked: "",
      },
      {
        id: 8,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 보존 및 보관기준에 적합한 온도가 유지될 수 있는 냉장･냉동시설",
        isChecked: "",
      },
      {
        id: 9,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 식품과 직접 접촉하는 부분은 위생적인 내수성 재질로서 씻기 쉽고, 열탕･증기･살균제 등으로 소독･살균이 가능",
        isChecked: "",
      },
      {
        id: 10,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 쥐･해충 등을 막을 수 있는 시설",
        isChecked: "",
      },
      {
        id: 11,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 바닥, 벽, 천장, 폐기물용기, 환기시설, 방충시설 등의 청결 관리",
        isChecked: "",
      },
      {
        id: 12,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 수돗물이나 먹는물의 수질기준에 적합한 지하수 등을 공급할 수 있는 시설",
        isChecked: "",
      },
      {
        id: 13,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 지하수를 사용하는 경우 취수원이 오염원의 영향을 받지 아니하는 곳에 위치\n- 축산농가의 분뇨 유입 가능성 여부 등",
        isChecked: "",
      },
      {
        id: 14,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 지하수를 사용하는 경우 용수저장장치에 살균소독장치를 설치",
        isChecked: "",
      },
      {
        id: 15,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 식품등을 위생적으로 보관할 수 있는 창고를 갖추었는지 여부",
        isChecked: "",
      },
      {
        id: 16,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 화장실은 조리장에 영향을 미치지 아니하는 장소에 설치\n※ 집단급식소가 위치한 건축물안에 시설기준에 적합한 공동화장실이 설치되어 있거나 인근에 사용하기 편리한 화장실이 있는 경우 제외",
        isChecked: "",
      },
      {
        id: 17,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 수세식이 아닌 화장실인 경우 변기의 뚜껑과 환기시설 구비",
        isChecked: "",
      },
      {
        id: 18,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 화장실은 콘크리트 등으로 내수처리를 하고, 바닥과 내벽(바닥으로부터 1.5미터까지)에는 타일을 붙이거나 방수페인트로 색칠",
        isChecked: "",
      },
      {
        id: 19,
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 화장실 내에 손을 씻는 시설",
        isChecked: "",
      },

      {
        id: 20,
        title: "3.건강진단 (법 제40조)",
        isChecked: "",
        contentType: 1,
      },

      {
        id: 21,
        title: "4. 개인위생 (법 제3조)",
        content: "· 식품등의 제조･가공･조리 또는 포장에 직접 종사하는 자는 위생모를 착용하는 등 개인위생관리에 철저를 기하는지 여부",
        isChecked: "",
      },
      {
        id: 22,
        title: "4. 개인위생 (법 제3조)",
        content: "· 식품의 조리 시 마스크 착용 여부",
        isChecked: "",
      },

      {
        id: 23,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 무허가(무신고·무등록)  원료 및 식품의 사용여부",
        isChecked: "",
      },
      {
        id: 24,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 부패･변질된 원료 및 식품의 사용여부",
        isChecked: "",
      },
      {
        id: 25,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 무표시 원료 및 식품의 사용여부",
        isChecked: "",
      },
      {
        id: 26,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 검사를 받지 아니한 축산물의 사용 유무",
        isChecked: "",
      },
      {
        id: 27,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 유통기한이 경과된 원료 또는 완제품을 조리할 목적으로 보관･사용",
        isChecked: "",
      },
      {
        id: 28,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 지하수 등을 먹는물 또는 식품의 조리, 세척 등에 사용하는 경우 먹는물수질검사기관에서 검사를 받아 마시기에 적합하다고 인정된 물을 사용하는지 여부\n(연1회 일부항목검사, 2년마다 전항목 검사)",
        isChecked: "",
      },
      {
        id: 29,
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 위해평가가 완료되기 전 일시적으로 금지된 식품 등 사용, 조리",
        isChecked: "",
      },

      {
        id: 30,
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 원료보관실, 제조가공실, 포장실등의 내부를 청결하게 관리",
        isChecked: "",
      },
      {
        id: 31,
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 동물의 내장을 조리한 경우 사용한 기계기구류 등을 세척･살균",
        isChecked: "",
      },
      {
        id: 32,
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 위생적인 방법으로 해동 실시하고, 해동 후 바로 사용하지 않는 경우 조리 시까지 냉장보관, 해동제품에 대한 재냉동 금지",
        isChecked: "",
      },
      {
        id: 33,
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 물수건, 숟가락, 젓가락, 식기, 찬기, 도마, 칼 및 행주 기타 주방용구는 식품첨가물인 기구 등 살균, 소독제 또는 열탕의 방법으로 소독한 것을 사용",
        isChecked: "",
      },
      {
        id: 34,
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 어류･육류･채소류를 취급하는 칼･도마는 각각 구분하여 사용",
        isChecked: "",
      },

      {
        id: 35,
        title: "7. 공정관리 (법 제3조, 제88조)",
        content: "· 식품등의 보관, 운반, 진열시에는 보존 및 보관기준(냉장 10℃, 냉동 -18℃ 이하)에 적합하도록 관리",
        isChecked: "",
      },
      {
        id: 36,
        title: "7. 공정관리 (법 제3조, 제88조)",
        content: "· 냉동･냉장시설 및 가열처리시설에는 온도계 또는 온도 측정 계기 설치",
        isChecked: "",
      },

      {
        id: 37,
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 집단급식소 설치운영자와 위탁계약한 사항 외의 영업행위를 하는지",
        isChecked: "",
      },
      {
        id: 38,
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 조리･제공한 식품(간식 포함)의 매회 1인분 분량을 -18℃ 이하에서 144시간 이상 보관하는지",
        isChecked: "",
      },
      {
        id: 39,
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 집단급식소의 설치･운영자가 위생교육을 받았는지\n※ 위탁급식영업자의 경우 영업자 위생교육 이수 여부",
        isChecked: "",
      },
      {
        id: 40,
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 조리사, 영양사 채용 및 교육 이수 여부\n※ 100인 미만 산업체 집단급식소의 경우 예외",
        isChecked: "",
      },
      {
        id: 41,
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 영리 목적의 영업 여부(불특정 다수에게 급식 제공 등)",
        isChecked: "",
      },
    ],
  },
  {
    title: "소규모 급식소(어린이집)",
    tableHeaderTitle: "점검사항",
    tableHeaderCheck: [{ text: "적합" }, { text: "부적합" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "▪ 시설 등 환경", content: "바닥, 벽, 천장, 폐기물 용기, 환기시설, 방충시설 등을 청결하게 관리하고 있다.", isChecked: "" },
      { id: 2, title: "▪ 시설 등 환경", content: "채광이 잘되고 기계 환기시설을 하여 청정한 실내 환경을 유지하고 있다.", isChecked: "" },
      { id: 3, title: "▪ 시설 등 환경", content: "창문에 방충망이 설치되어 있다.", isChecked: "" },
      { id: 4, title: "▪ 시설 등 환경", content: "주방용 식기류를 소독하기 위한 자외선 또는 전기살균소독기를 설치하거나 열탕세척 소독시설을 갖추어야 한다.", isChecked: "" },
      { id: 5, title: "▪ 개인위생", content: "조리원 및 급식·배식인력(교사, 원장)의 건강진단을 실시 하였다.", isChecked: "" },
      { id: 6, title: "▪ 개인위생", content: "작업 중인 조리원 등은 위생모·마스크·위생복·위생화·앞치마·위생장갑 등을 착용하여야 한다.", isChecked: "" },
      { id: 7, title: "▪ 개인위생", content: "작업 중인 조리원은 귀걸이, 반지, 매니큐어 등 개인용 장신구 등을 착용하여서는 아니된다.", isChecked: "" },
      { id: 8, title: "▪ 원료사용", content: "무허가(무신고) 원료 및 식품을 사용하지 아니한다.", isChecked: "" },
      { id: 9, title: "▪ 원료사용", content: "부패･변질된 원료 및 식품을 사용 및 보관하지 아니한다.", isChecked: "" },
      { id: 10, title: "▪ 원료사용", content: "무표시 원료 및 식품을 사용하지 아니한다.", isChecked: "" },
      { id: 11, title: "▪ 원료사용", content: "식재료에 원산지 표시를 하여야 한다.", isChecked: "" },
      { id: 12, title: "▪ 원료사용", content: "유통기한이 경과된 원료 또는 완제품을 조리할 목적으로 보관하거나 이를 음식물의 조리에 사용하지 아니한다.", isChecked: "" },
      { id: 13, title: "▪ 원료사용", content: "음용수는 상수도 및 간이상수도를 사용하는 경우 물을 끓여 사용하거나 정수장치가 있는 경우 정기적인 필터 교환 등으로 수질관리를 하여야 한다.", isChecked: "" },
      { id: 14, title: "▪ 원료사용", content: "음용수로 지하수를 사용하는 경우 수질검사기관으로부터 발급받은 수질검사성적서 구비하여야 한다.", isChecked: "" },
      { id: 15, title: "▪ 원료사용", content: "위해평가가 완료되기 전 일시적으로 금지된 식품 등 사용, 조리하지 아니한다.", isChecked: "" },
      { id: 16, title: "▪ 공정관리", content: "원료보관실･조리실 등의 내부를 청결하게 관리한다.", isChecked: "" },
      { id: 17, title: "▪ 공정관리", content: "식기, 도마, 칼, 행주 기타 주방용구는 기구 등의 살균･소독제 또는 열탕의 방법으로 소독한 것을 사용하여야 한다.", isChecked: "" },
      { id: 18, title: "▪ 공정관리", content: "칼과 도마 등의 조리기구는 교차오염을 방지하기 위하여 어류･육류･채소류를 구분하여 사용하여야 한다.", isChecked: "" },
      { id: 19, title: "▪ 공정관리", content: "식품 취급 등의 작업은 바닥으로부터 60cm 이상의 높이에서 실시하고, 보관은 바닥과 벽으로부터 15cm이상 떨어진 곳에 보관하여야 한다.", isChecked: "" },
      { id: 20, title: "▪ 공정관리", content: "가열조리하지 않는 음식물의 식재료는 염소소독 등을 실시하고 충분히 세척하여야 한다.", isChecked: "" },
      { id: 21, title: "▪ 공정관리", content: "해동은 냉장해동(10℃ 이하), 전자레인지 해동, 또는 흐르는 물에서 실시하고 해동된 식품은 즉시 사용하여야 한다.", isChecked: "" },
      { id: 22, title: "▪ 공정관리", content: "육류, 어류 등 동물성원료를 가열 조리하는 경우에는 식품의 중심부까지 충분히 익힌다.", isChecked: "" },
      { id: 23, title: "▪ 공정관리", content: "행주(청소용, 배식용, 조리용), 사용장갑 및 앞치마는 용도별로 구분 사용하여야 한다.", isChecked: "" },
      { id: 24, title: "▪ 공정관리", content: "조리시설의 세척·소독 등 위생 관리하여야 한다.", isChecked: "" },
      { id: 25, title: "▪ 공정관리", content: "조리된 음식은 2시간 이내에 섭취완료 되도록 관리 하여야 한다.", isChecked: "" },
      { id: 26, title: "▪ 공정관리", content: "배식 시 올바른 위생복장(위생앞치마, 위생마스크, 위생장갑)을 착용하여야 한다.", isChecked: "" },
      { id: 27, title: "▪ 보관관리", content: "식품등의 원료 및 제품 중 부패･변질이 되기 쉬운 것은 냉장･냉동시설에 보관･관리하여야 한다.", isChecked: "" },
      { id: 28, title: "▪ 보관관리", content: "냉장시설은 내부의 온도를 5℃ 이하(유치원 및 어린이집은 0~5℃ 권장), 냉동시설은 –18℃로 유지하여야 한다.", isChecked: "" },
      { id: 29, title: "▪ 기타사항", content: "급식을 어린이집에서 직접 조리하여 제공하여야 한다. (* 어린이집의 경우에 해당)", isChecked: "" },
      { id: 30, title: "▪ 기타사항", content: "조리·제공한 식품의 매회 1인분 분량을 –18℃ 이하에서 144시간 이상 보관하여야 한다. (* 현원 21~49명 어린이집만 해당)", isChecked: "" },
      { id: 31, title: "▪ 기타사항", content: "이미 급식에 제공되었던 음식물 재사용 하면 아니된다.", isChecked: "" },
      { id: 32, title: "▪ 기타사항", content: "조리실, 식품 등의 원료·제품 보관실 등을 정기적으로 소독하여야 한다.", isChecked: "" },
    ],
  },
  {
    title: "위생분야",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "작업장 환경 및 개인 위생", content: "1. 손 씻기 시설(세면대)과 비누, 건조기(종이 타월) 등이 충분히 비치되어 있는가?", isChecked: "" },
      { id: 2, title: "작업장 환경 및 개인 위생", content: "2. 작업에 적합한 보호복, 마스크, 보호구(PPE)를 정기적으로 지급하고 올바르게 착용하는가?", isChecked: "" },
      { id: 3, title: "작업장 환경 및 개인 위생", content: "3. 밀폐된 작업 공간의 환기 상태가 양호하며, 유해 증기나 분진이 원활히 배출되는가?", isChecked: "" },
      { id: 4, title: "작업장 환경 및 개인 위생", content: "4. 개인 사물함이 청결하게 유지되며, 작업복과 개인 의류가 분리 보관되는가?", isChecked: "" },
      { id: 5, title: "시설 및 기계설비 안전", content: "5. 통로, 계단 및 비상구에 장애물이 적재되어 있지 않고 대피 경로가 확보되어 있는가?", isChecked: "" },
      { id: 6, title: "옥내소화전 및 스프링클러", content: "6. 바닥에 미끄럼 방지 조치가 되어 있으며, 물기나 기름기로 인한 낙상 위험은 없는가?", isChecked: "" },
      { id: 7, title: "옥내소화전 및 스프링클러", content: "7. 전기 기구의 노출 전선은 없으며, 습기가 많은 곳의 콘센트는 방우형 커버가 설치되어 있는가?", isChecked: "" },
      { id: 8, title: "옥내소화전 및 스프링클러", content: "8. 회전체나 위험 기계·설비에 안전 덮개와 비상 정지 장치가 정상 작동하는가?", isChecked: "" },
      { id: 9, title: "세척·소독 및 폐기물 관리", content: "9. 식기, 도구, 작업대 등의 세척 및 살균 소독이 기준에 맞게 주기적으로 이루어지는가?", isChecked: "" },
      { id: 10, title: "세척·소독 및 폐기물 관리", content: "10. 화학약품(세제, 소독제)은 지정된 장소에 보관하며 물질안전보건자료(MSDS)가 비치되어 있는가?", isChecked: "" },
      { id: 11, title: "세척·소독 및 폐기물 관리", content: "11. 폐기물 및 음식물 쓰레기는 밀폐된 전용 용기에 담아 수시로 배출하는가?", isChecked: "" },
      { id: 12, title: "세척·소독 및 폐기물 관리", content: "12. 해충 및 설치류 방제(Pest Control) 프로그램이 정기적으로 운영되고 있는가?", isChecked: "" },
      { id: 13, title: "비상조명등", content: "13. 소화기 및 비상 조명등의 위치를 전 직원이 인지하고 있으며, 점검표 기록이 유지되는가?", isChecked: "" },
      { id: 14, title: "비상조명등", content: "14. 가스 사용 시설의 경우 누출 여부를 정기적으로 확인하고 있는가?", isChecked: "" },
      { id: 15, title: "비상조명등", content: "15. 비상시 행동 요령과 응급처치 도구(구급상자)가 눈에 잘 띄는 곳에 비치되어 있는가?", isChecked: "" },
    ],
  },
  {
    title: "승강기(엘리베이터)",
    tableHeaderTitle: "주요내용",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        content: "1. 승강기 내·외부 안전수칙 부착 여부",
        isChecked: "",
      },
      {
        id: 2,
        content: "2. 승강기 검사합격증명서 부착 여부",
        isChecked: "",
      },
      {
        id: 3,
        content: "3. 비상운전 및 작동시험을 위한 장치",
        isChecked: "",
      },
      {
        id: 4,
        content: "4. 승강로 내 출입문, 비상문 및 점검문 작동상태",
        isChecked: "",
      },
      {
        id: 5,
        content: "5. 승강장문 문짝과 문짝, 문틀, 문턱 사이의 틈새",
        isChecked: "",
      },
      {
        id: 6,
        content: "6. 어린이 손끼임방지수단 설치상태",
        isChecked: "",
      },
      {
        id: 7,
        content: "7. 비상통화장치 작동상태",
        isChecked: "",
      },
      {
        id: 8,
        content: "8. 문닫힘안전장치 작동상태",
        isChecked: "",
      },
      {
        id: 9,
        content: "9. 추락방지안전장치 작동상태",
        isChecked: "",
      },
      {
        id: 10,
        content: "10. 문열림출발방지장치 작동상태",
        isChecked: "",
      },
      {
        id: 11,
        content: "11. 호출버튼, 조작반, 통화장치 등 작동상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "승강기(에스컬레이터)",
    tableHeaderTitle: "주요내용",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "표시부착", content: "1. 승강장 주의표시 부착 여부", isChecked: "" },
      { id: 2, title: "표시부착", content: "2. 검사합격증명서 부착 여부", isChecked: "" },
      { id: 3, title: "승·하강부", content: "3. 콤(빗살) 치아가 깨지거나 손상된 곳이 없는가?", isChecked: "" },
      { id: 4, title: "승·하강부", content: "4. 디딤판과 콤 사이의 이물질이 없고 수평이 잘 맞는가?", isChecked: "" },
      { id: 5, title: "디딤판", content: "5. 디딤판이 파손되거나 찌그러짐, 또는 덜컹거림이 없는가?", isChecked: "" },
      { id: 6, title: "디딤판", content: "6. 디딤판 가장자리의 황색 안전 도색이 선명하게 유지되어 있는가?", isChecked: "" },
      { id: 7, title: "운행 상태", content: "7. 가동 시 쇠가 갈리는 소리나 덜그럭거리는 이상 진동이 없는가?", isChecked: "" },
      { id: 8, title: "운행 상태", content: "8. 핸드레일과 발판의 이동 속도가 일치하는가?", isChecked: "" },
      { id: 9, title: "핸드레일", content: "9. 핸드레일 표면에 균열이 있거나, 멈춤/미끄러짐 현상이 없는가?", isChecked: "" },
      { id: 10, title: "핸드레일", content: "10. 손잡이가 들어가는 입구에 손가락 끼임 등의 방호장치가 정상인가?", isChecked: "" },
      { id: 11, title: "측면 및 하단", content: "11. 발판 측면(스커트)과 틈새 브러시가 마모되거나 파손되지 않았는가?", isChecked: "" },
      { id: 12, title: "측면 및 하단", content: "12. 측면 틈새에 신발이나 옷자락이 말려 들어갈 위험 요소는 없는가?", isChecked: "" },
      { id: 13, title: "안전 장치", content: "13. 상·하단 비상정지 버튼이 눈에 잘 띄며 작동이 원활한가?", isChecked: "" },
      { id: 14, title: "안전 장치", content: "14. 접근 인원을 감지하여 속도 제어 및 자동 출발/정지가 잘 되는가?", isChecked: "" },
      { id: 15, title: "주변 환경", content: "15. 에스컬레이터 승·하강부 바닥에 턱이 있거나 미끄러운 곳은 없는가?", isChecked: "" },
      { id: 16, title: "주변 환경", content: "16. 탑승 구역 조명이 밝고, 이용자 안전 수칙 표지판이 잘 보이는가?", isChecked: "" },
    ],
  },
  {
    title: "어린이놀이시설",
    tableHeaderTitle: "점검항목",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    list: [
      {
        id: 1,
        title: "관리자 의무사항",
        content: "• 정기시설검사(최초 설치검사) 실시 여부 (2년에 1회 이상)",
        isChecked: "",
      },
      {
        id: 2,
        title: "관리자 의무사항",
        content: "• 설치검사 및 정기시설검사에 합격되었음을 나타내는 표시",
        isChecked: "",
      },
      {
        id: 3,
        title: "관리자 의무사항",
        content: "• 검사를 받지 않았거나 불합격된 시설의 이용금지 조치",
        isChecked: "",
      },
      {
        id: 4,
        title: "관리자 의무사항",
        content: "• 자체 안전점검 실시 및 점검(진단)기록 보관 (월1회, 3년간 보관)",
        isChecked: "",
      },
      {
        id: 5,
        title: "관리자 의무사항",
        content: "• 안전관리자 변경 및 시설물 인도 후 안전교육 이수 (3개월 이내)",
        isChecked: "",
      },
      {
        id: 6,
        title: "관리자 의무사항",
        content: "• 안전관리자의 안전교육 이수 (2년에 1회 이상, 4시간 이상, 유효기간 만료일 전 3개월)",
        isChecked: "",
      },
      {
        id: 7,
        title: "관리자 의무사항",
        content: "• 보험 가입 (시설물 인도 후 30일 이내, 사망시 8천만원까지 보상)",
        isChecked: "",
      },
      {
        id: 8,
        title: "부대시설",
        content: "• 울타리, 의자, 가로등의 고장 또는 파손",
        isChecked: "",
      },
      {
        id: 9,
        title: "부대시설",
        content: "• 화장실의 파손 및 청결 ",
        isChecked: "",
      },
      {
        id: 10,
        title: "부대시설",
        content: "• 식수대, 쓰레기 처리대의 파손 및 청결 ",
        isChecked: "",
      },
      {
        id: 11,
        title: "부대시설",
        content: "• 놀이터 표지판의 파손 및 내용물 지워짐",
        isChecked: "",
      },
      {
        id: 12,
        title: "놀이터 공통사항",
        content: "• 모든 놀이기구 및 시설의 낙후, 휘어짐",
        isChecked: "",
      },
      {
        id: 13,
        title: "놀이터 공통사항",
        content: "• 움직임이 많은 영역에 밧줄이나 전선의 늘어짐",
        isChecked: "",
      },
      {
        id: 14,
        title: "놀이터 공통사항",
        content: "• 놀이터내 전기, 고압선, 유독물질, 유리조각 등 위험물질 존재",
        isChecked: "",
      },
      {
        id: 15,
        title: "놀이터 공통사항",
        content: "• 유실 모래의 보충 및 굳은 모래 부수기",
        isChecked: "",
      },
      {
        id: 16,
        title: "놀이터 공통사항",
        content: "• 놀이터의 배수, 쓰레기 적재 및 입구의 주차 상태",
        isChecked: "",
      },
      {
        id: 17,
        title: "놀이터 공통사항",
        content: "• 기둥의 고정 및 조임 장치의 조임 상태",
        isChecked: "",
      },
      {
        id: 18,
        title: "놀이터 공통사항",
        content: "• 기구 및 시설의 베어링의 윤활",
        isChecked: "",
      },
      {
        id: 19,
        title: "놀이터 공통사항",
        content: "• 기구 및 시설의 도장 상태",
        isChecked: "",
      },
      {
        id: 20,
        title: "그네",
        content: "• 그네고리(‘S’ 훅)의 풀림 및 파손",
        isChecked: "",
      },
      {
        id: 21,
        title: "그네",
        content: "• 그네 좌석판의 파손",
        isChecked: "",
      },
      {
        id: 22,
        title: "그네",
        content: "• 그네 회동구 베어링의 윤활유 주입 상태",
        isChecked: "",
      },
      {
        id: 23,
        title: "그네",
        content: "• 그네 줄의 꼬임 ",
        isChecked: "",
      },
      {
        id: 24,
        title: "그네",
        content: "• 그네 체인의 모양 변형",
        isChecked: "",
      },
      {
        id: 25,
        title: "그네",
        content: "• 그네 줄의 균형 상태",
        isChecked: "",
      },
      {
        id: 26,
        title: "그네",
        content: "• 그네 추락지대까지 바닥재의 충분 여부, 추락시 상해위험 장애물 존재",
        isChecked: "",
      },
      {
        id: 27,
        title: "그네",
        content: "• 신체부위가 낄 수 있는 틈새의 존재",
        isChecked: "",
      },
      {
        id: 28,
        title: "그네",
        content: "• 금속재질의 녹 발생",
        isChecked: "",
      },
      {
        id: 29,
        title: "그네",
        content: "• 금이 간 곳의 존재",
        isChecked: "",
      },
      {
        id: 30,
        title: "그네",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 31,
        title: "그네",
        content: "• 돌출부나 거친면의 존재",
        isChecked: "",
      },
      {
        id: 32,
        title: "그네",
        content: "• 볼트나 나사의 풀림",
        isChecked: "",
      },
      {
        id: 33,
        title: "미끄럼틀",
        content: "• 미끄럼틀 보호벽(난간)의 파손",
        isChecked: "",
      },
      {
        id: 34,
        title: "미끄럼틀",
        content: "• 미끄럼틀 계단의 파손",
        isChecked: "",
      },
      {
        id: 35,
        title: "미끄럼틀",
        content: "• 미끄럼틀 활주판의 요철 및 파손",
        isChecked: "",
      },
      {
        id: 36,
        title: "미끄럼틀",
        content: "• 착지판에 흙 및 물의 존재",
        isChecked: "",
      },
      {
        id: 37,
        title: "미끄럼틀",
        content: "• 신체부위가 낄 수 있는 틈새의 존재",
        isChecked: "",
      },
      {
        id: 38,
        title: "미끄럼틀",
        content: "• 금속 재질의 녹 발생 상태",
        isChecked: "",
      },
      {
        id: 39,
        title: "미끄럼틀",
        content: "• 금이 간 곳의 존재",
        isChecked: "",
      },
      {
        id: 40,
        title: "미끄럼틀",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 41,
        title: "미끄럼틀",
        content: "• 돌출부나 거친면의 존재",
        isChecked: "",
      },
      {
        id: 42,
        title: "미끄럼틀",
        content: "• 볼트나 나사의 풀림",
        isChecked: "",
      },
      {
        id: 43,
        title: "흔들놀이기구",
        content: "• 시소의 무게 균형 상태",
        isChecked: "",
      },
      {
        id: 44,
        title: "흔들놀이기구",
        content: "• 충격 완화용 타이어의 파손",
        isChecked: "",
      },
      {
        id: 45,
        title: "흔들놀이기구",
        content: "• 지지대와 시소판의 연결부위의 원활성 및 회전성",
        isChecked: "",
      },
      {
        id: 46,
        title: "흔들놀이기구",
        content: "• 시소가 좌‧우로 흔들림",
        isChecked: "",
      },
      {
        id: 47,
        title: "흔들놀이기구",
        content: "• 손잡이가 흔들림",
        isChecked: "",
      },
      {
        id: 48,
        title: "흔들놀이기구",
        content: "• 신체부위(손, 발, 머리)가 낄 수 있는 틈새",
        isChecked: "",
      },
      {
        id: 49,
        title: "흔들놀이기구",
        content: "• 금속부분의 녹슴, 목재부분의 부식",
        isChecked: "",
      },
      {
        id: 50,
        title: "흔들놀이기구",
        content: "• 기구의 금이 간 곳",
        isChecked: "",
      },
      {
        id: 51,
        title: "흔들놀이기구",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 52,
        title: "흔들놀이기구",
        content: "• 돌출부나 거칠음",
        isChecked: "",
      },
      {
        id: 53,
        title: "흔들놀이기구",
        content: "• 볼트나 너트 등의 나사풀림",
        isChecked: "",
      },
      {
        id: 54,
        title: "회전놀이기구",
        content: "• 회전상태(베어링 상태)",
        isChecked: "",
      },
      {
        id: 55,
        title: "회전놀이기구",
        content: "• 손잡이의 파손",
        isChecked: "",
      },
      {
        id: 56,
        title: "회전놀이기구",
        content: "• 회전판의 기울어짐이나 흔들림",
        isChecked: "",
      },
      {
        id: 57,
        title: "회전놀이기구",
        content: "• 회전축의 파손, 기울어짐, 흔들림",
        isChecked: "",
      },
      {
        id: 58,
        title: "회전놀이기구",
        content: "• 회전축의 움직이는 부분의 노출",
        isChecked: "",
      },
      {
        id: 59,
        title: "회전놀이기구",
        content: "• 신체부위(손, 발, 머리)가 낄 수 있는 틈새",
        isChecked: "",
      },
      {
        id: 60,
        title: "회전놀이기구",
        content: "• 금속부분의 녹슴, 목재부분의 부식",
        isChecked: "",
      },
      {
        id: 61,
        title: "회전놀이기구",
        content: "• 금이 간 곳의 존재",
        isChecked: "",
      },
      {
        id: 62,
        title: "회전놀이기구",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 63,
        title: "회전놀이기구",
        content: "• 돌출부나 거칠음",
        isChecked: "",
      },
      {
        id: 64,
        title: "회전놀이기구",
        content: "• 볼트나 너트 등의 나사풀림",
        isChecked: "",
      },
      {
        id: 65,
        title: "정글짐·건너는 기구",
        content: "• 파이프가 휘어짐",
        isChecked: "",
      },
      {
        id: 66,
        title: "정글짐·건너는 기구",
        content: "• 금속부분의 녹슴",
        isChecked: "",
      },
      {
        id: 67,
        title: "정글짐·건너는 기구",
        content: "• 금이 간 곳의 존재",
        isChecked: "",
      },
      {
        id: 68,
        title: "정글짐·건너는 기구",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 69,
        title: "정글짐·건너는 기구",
        content: "• 돌출부나 거칠음",
        isChecked: "",
      },
      {
        id: 70,
        title: "정글짐·건너는 기구",
        content: "• 볼트나 너트 등의 나사풀림",
        isChecked: "",
      },
      {
        id: 71,
        title: "오르는 기구",
        content: "• 그물망(체인, 타이어) 사이의 연결 부위 고정성",
        isChecked: "",
      },
      {
        id: 72,
        title: "오르는 기구",
        content: "• 손잡이(파이프, 체인, 타이어)의 파손(갈라짐, 휘어짐, 엉킴, 벗겨짐)",
        isChecked: "",
      },
      {
        id: 73,
        title: "오르는 기구",
        content: "• 지지대가 느슨해졌는 지 여부",
        isChecked: "",
      },
      {
        id: 74,
        title: "오르는 기구",
        content: "• 신체부위(손, 발, 머리)가 낄 수 있는 틈새",
        isChecked: "",
      },
      {
        id: 75,
        title: "오르는 기구",
        content: "• 금속부분의 녹슴, 목재부분의 부식",
        isChecked: "",
      },
      {
        id: 76,
        title: "오르는 기구",
        content: "• 금이 간 곳의 존재",
        isChecked: "",
      },
      {
        id: 77,
        title: "오르는 기구",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 78,
        title: "오르는 기구",
        content: "• 돌출부나 거칠음",
        isChecked: "",
      },
      {
        id: 79,
        title: "오르는 기구",
        content: "• 볼트나 너트 등의 나사풀림",
        isChecked: "",
      },
      {
        id: 80,
        title: "건너는 기구·공중놀이기구",
        content: "• 손잡이 파이프(혹은 링)가 파손(갈라짐, 휘어짐)",
        isChecked: "",
      },
      {
        id: 81,
        title: "건너는 기구·공중놀이기구",
        content: "• 신체부위(손, 발, 머리)가 낄 수 있는 틈새",
        isChecked: "",
      },
      {
        id: 82,
        title: "건너는 기구·공중놀이기구",
        content: "• 금속부분의 녹슴, 목재부분의 부식",
        isChecked: "",
      },
      {
        id: 83,
        title: "건너는 기구·공중놀이기구",
        content: "• 금이 간 곳의 존재",
        isChecked: "",
      },
      {
        id: 84,
        title: "건너는 기구·공중놀이기구",
        content: "• 페인트 칠이 벗겨짐",
        isChecked: "",
      },
      {
        id: 85,
        title: "건너는 기구·공중놀이기구",
        content: "• 돌출부나 거칠음",
        isChecked: "",
      },
      {
        id: 86,
        title: "건너는 기구·공중놀이기구",
        content: "• 볼트나 너트 등의 나사풀림",
        isChecked: "",
      },
      {
        id: 87,
        title: "물이용 놀이기구",
        content: "• 급·배수 상태(물공급 노즐, 오버플로우, 배수구 등)",
        isChecked: "",
      },
      {
        id: 88,
        title: "물이용 놀이기구",
        content: "• 매달려 있는 구동구조물 상태(베어링, 이중안전장치 등)",
        isChecked: "",
      },
      {
        id: 89,
        title: "물이용 놀이기구",
        content: "• 미끄럼방지 조치 상태(테잎, 매트 등)",
        isChecked: "",
      },
      {
        id: 90,
        title: "물이용 놀이기구",
        content: "• 수질오염 상태(부유물질 등)",
        isChecked: "",
      },
      {
        id: 91,
        title: "물이용 놀이기구",
        content: "• 기초부, 연결부 등의 물고임 및 부식 상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "실내어린이놀이시설",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "체험공간", content: "습기 등 미끄러짐 사고 위험요인이 있습니까?", isChecked: "" },
      { id: 2, title: "체험공간", content: "바닥에 이물질, 돌출부위, 작업용 부품, 위험물질(날카로운 물질 등)이 있습니까?", isChecked: "" },
      { id: 3, title: "체험공간", content: "안전장치가 없어 끼임, 부딪힘 사고 등 위험이 있는 체험 기계·장치가 있습니까?", isChecked: "" },
      { id: 4, title: "체험공간", content: "보호장치를 하지 않아 부딪힘 사고를 발생하는 위험요인(모서리 등)이 있습니까?", isChecked: "" },
      { id: 5, title: "체험공간", content: "걸림, 넘어짐 사고를 발생시킬 수 있는 높은 턱 등 위험요인이 있습니까?", isChecked: "" },
      { id: 6, title: "파티룸", content: "습기 등 미끄러짐 사고 위험요인이 있습니까?", isChecked: "" },
      { id: 7, title: "파티룸", content: "찔림, 베임 사고를 발생시킬 수 있는 날카로운 비품 등이 방치되어 있습니까?", isChecked: "" },
      { id: 8, title: "파티룸", content: "안전장치를 하지 않아 감전 사고를 발생시킬 수 있는 전기 콘센트가 있습니까?", isChecked: "" },
      { id: 9, title: "파티룸", content: "화재를 발생시킬 수 있는 위험요소가 있습니까?", isChecked: "" },
      { id: 10, title: "놀이기구 및 공간", content: "바닥에 고정되어 있는 놀이기구 중 고정부에서 이탈 위험이 있는 놀이기구가 있습니까?", isChecked: "" },
      { id: 11, title: "놀이기구 및 공간", content: "영유아의 몸이 끼이는 놀이기구의 틈새나 간격이 있습니까?", isChecked: "" },
      { id: 12, title: "놀이기구 및 공간", content: "놀이기구의 기초대, 지지대 등 매설 부분이 노출되어 있습니까?", isChecked: "" },
      { id: 13, title: "놀이기구 및 공간", content: "바닥 충격흡수재의 성능이 노후되어 있습니까?", isChecked: "" },
      { id: 14, title: "놀이기구 및 공간", content: "보수가 필요한 놀잇감 및 놀이기구가 방치되어 있습니까?", isChecked: "" },
      { id: 15, title: "로비 및 카페테리아", content: "습기 등 미끄러짐 사고 위험요인이 있습니까?", isChecked: "" },
      { id: 16, title: "로비 및 카페테리아", content: "걸림, 넘어짐 사고를 발생시킬 수 있는 높은 턱 등 위험요인이 있습니까?", isChecked: "" },
      { id: 17, title: "현관, 통로, 계단, 비상구", content: "습기 등 미끄러짐 사고 위험요인이 있습니까?", isChecked: "" },
      { id: 18, title: "현관, 통로, 계단, 비상구", content: "걸림, 넘어짐 사고를 발생시킬 수 있는 높은 턱 등 위험요인이 있습니까?", isChecked: "" },
      { id: 19, title: "현관, 통로, 계단, 비상구", content: "안전난간, 미끄럼방지장치 등이 없어 추락, 미끄러짐 사고를 발생시킬 수 있는 계단이 있습니까?", isChecked: "" },
      { id: 20, title: "현관, 통로, 계단, 비상구", content: "유사시 대피에 장애가 되는 물건, 적치물 등 장애요소가 있습니까?", isChecked: "" },
      { id: 21, title: "화장실", content: "습기 등 미끄러짐 사고 위험 요인이 있습니까?", isChecked: "" },
      { id: 22, title: "화장실", content: "세제나 락스 등 위험한 물건이 이용객들의 손이 닿는 곳에 방치되어 있습니까?", isChecked: "" },
      { id: 23, title: "화장실", content: "고정상태가 느슨한 세면대 등 위험요인이 있습니까?", isChecked: "" },
    ],
  },
  {
    title: "어린이집",
    tableHeaderTitle: "평가항목",
    tableHeaderCheck: [{ text: "적합" }, { text: "부적합" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "내용(위치, 상태)", width: "240" }, { text: "조치사항", width: "240" }],
    list: [
      { id: 1, title: "시설안전", content: "창문에는 방호창이 설치되어 있나요?", isChecked: "" },
      { id: 2, title: "시설안전", content: "창문은 열고 닫는데 힘들지 않나요?", isChecked: "" },
      { id: 3, title: "시설안전", content: "내·외부 및 천장 마감재는 탈락, 들뜸, 추락의 위험은 없나요?", isChecked: "" },
      { id: 4, title: "시설안전", content: "옥외 간판은 튼튼하게 지탱하고 있나요?", isChecked: "" },
      { id: 5, title: "시설안전", content: "건물 주변 지반침하 또는 웅덩이가 만들어지지 않았나요?", isChecked: "" },
      { id: 6, title: "시설안전", content: "천장에서 물이 새는 곳은 없나요?", isChecked: "" },
      { id: 7, title: "시설안전", content: "계단은 미끄럼방지 처리가 되어 있나요?", isChecked: "" },
      { id: 8, title: "시설안전", content: "날카로운 모서리에는 충격완화 패드가 부착되어 있나요?", isChecked: "" },
      { id: 9, title: "전기안전", content: "「전기사업법」에 의한 법적 정기검사(점검)을 받았나요?", isChecked: "" },
      { id: 10, title: "전기안전", content: "전원 차단형(스위치) 멀티탭을 사용하고 있나요?", isChecked: "" },
      { id: 11, title: "전기안전", content: "분전반, 콘센트, 전기제품에 먼지나 이물질은 없나요?", isChecked: "" },
      { id: 12, title: "전기안전", content: "누전차단기의 황색 또는 적색 버튼을 눌렀을 때 손잡이가 내려가나요?", isChecked: "" },
      { id: 13, title: "전기안전", content: "전선, 플러그, 콘센트의 외부에 손상된 부분은 없나요?", isChecked: "" },
      { id: 14, title: "전기안전", content: "미사용 콘센트는 안전덮개로 막아 두었나요?", isChecked: "" },
      { id: 15, title: "전기안전", content: "욕실 등 습기가 많은 곳의 콘센트는 방수 덮개를 사용하고 있나요?", isChecked: "" },
      { id: 16, title: "전기안전", content: "퇴근할 때 전기제품의 전원을 차단하고 있나요?", isChecked: "" },
      { id: 17, title: "전기안전", content: "비인가 전열기구의 사용을 제한하고 있나요?", isChecked: "" },
      { id: 18, title: "가스안전", content: "관계법령에 의한 정기검사(점검)를 받았나요?", isChecked: "" },
      { id: 19, title: "가스안전", content: "가스렌지 등 연소기 사용 전·후 충분히 환기를 하셨나요?", isChecked: "" },
      { id: 20, title: "가스안전", content: "배관 이음부에 비눗물 칠했을 때 거품이 나는 곳은 없나요?", isChecked: "" },
      { id: 21, title: "가스안전", content: "가스기구를 사용하지 않는 경우 배관 끝 부분을 금속 플러그로 막음해 놓았나요?", isChecked: "" },
      { id: 22, title: "가스안전", content: "보일러나 온수기에 시공 내역이 포함된 표지판이 부착되어 있나요?", isChecked: "" },
      { id: 23, title: "가스안전", content: "보일러나 온수기의 배기통은 인증 제품으로 설치되어 있나요?", isChecked: "" },
      { id: 24, title: "가스안전", content: "배기통의 이음부는 내열실리콘으로 틈이 없게 막아 놓았나요?", isChecked: "" },
      { id: 25, title: "가스안전", content: "가스누출 자동차단장치가 설치되어 있나요?", isChecked: "" },
      { id: 26, title: "가스안전", content: "가스누출 자동 차단장치의 열고 닫는 버튼이 잘 작동 하나요?", isChecked: "" },
      { id: 27, title: "가스안전", content: "가스누출 자동 차단장치와 연결된 가스 검지부 전원 램프에 불이 들어와 있나요?", isChecked: "" },
    ],
  },
  {
    title: "교량분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        id: 1,
        title: "배수시설",
        content: "∙ 배수관 파손에 따른 낙하위험 유무",
        isChecked: "",
      },
      {
        id: 2,
        title: "배수시설",
        content: "∙ 배수관 막힘·물고임의 발생여부",
        isChecked: "",
      },
      {
        id: 3,
        title: "신축이음",
        content: "∙ 유간이격의 발생 여부",
        isChecked: "",
      },
      {
        id: 4,
        title: "신축이음",
        content: "∙ 단차의 발생 여부",
        isChecked: "",
      },
      {
        id: 5,
        title: "신축이음",
        content: "∙ 파손의 발생 여부",
        isChecked: "",
      },
      {
        id: 6,
        title: "받침부",
        content: "∙ 받침장치 파손의 발생 여부",
        isChecked: "",
      },
      {
        id: 7,
        title: "받침부",
        content: "∙ 받침부 균열, 파손의 발생 여부",
        isChecked: "",
      },
      {
        id: 8,
        title: "받침부",
        content: "∙ 받침편기의 발생 여부",
        isChecked: "",
      },
      {
        id: 9,
        title: "받침부",
        content: "∙ 받침과 거더의 분리 여부",
        isChecked: "",
      },
      {
        id: 10,
        title: "교대·교각",
        content: "∙ 균열의 발생 여부",
        isChecked: "",
      },
      {
        id: 11,
        title: "교대·교각",
        content: "∙ 파손의 발생 여부",
        isChecked: "",
      },
      {
        id: 12,
        title: "교대·교각",
        content: "∙ 변형, 회전의 발생 여부",
        isChecked: "",
      },
      {
        id: 13,
        title: "기초",
        content: "∙ 세굴의 발생 여부",
        isChecked: "",
      },
      {
        id: 14,
        title: "기초",
        content: "∙ 침하의 발생 여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "터널분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        id: 1,
        title: "갱문 및 옹벽",
        content: "∙ 신규균열·박락발생 유무",
        isChecked: "",
      },
      {
        id: 2,
        title: "갱문 및 옹벽",
        content: "∙ 주변지반의 세굴 발생여부",
        isChecked: "",
      },
      {
        id: 3,
        title: "갱문 및 옹벽",
        content: "∙ 주변지반의 융기 발생여부",
        isChecked: "",
      },
      {
        id: 4,
        title: "갱문 및 옹벽",
        content: "∙ 주변지반의 침하 발생여부",
        isChecked: "",
      },
      {
        id: 5,
        title: "갱문 및 옹벽",
        content: "∙ 시공이음부 단차발생 유무",
        isChecked: "",
      },
      {
        id: 6,
        title: "갱문 및 옹벽",
        content: "∙ 배수구 막힘 여부",
        isChecked: "",
      },
      {
        id: 7,
        title: "갱문 및 옹벽",
        content: "∙ 배수시 흙, 모래 유출여부",
        isChecked: "",
      },
      {
        id: 8,
        title: "갱구주변 경사면",
        content: "∙ 균열의 발생여부",
        isChecked: "",
      },
      {
        id: 9,
        title: "갱구주변 경사면",
        content: "∙ 침하 또는 융기의 발생 여부",
        isChecked: "",
      },
      {
        id: 10,
        title: "갱구주변 경사면",
        content: "∙ 새로운 지하수 유출지점 발생 여부",
        isChecked: "",
      },
      {
        id: 11,
        title: "갱구주변 경사면",
        content: "∙ 수목의 전도 여부",
        isChecked: "",
      },
      {
        id: 12,
        title: "갱구주변 경사면",
        content: "∙ 낙석 발생 여부",
        isChecked: "",
      },
      {
        id: 13,
        title: "사면 보호공 또는 보강공",
        content: "∙ 단차발생 여부",
        isChecked: "",
      },
      {
        id: 14,
        title: "사면 보호공 또는 보강공",
        content: "∙ 보호공 또는 보강공 파손발생 여부",
        isChecked: "",
      },
      {
        id: 15,
        title: "사면 보호공 또는 보강공",
        content: "∙ 배수공의 막힘 여부",
        isChecked: "",
      },
      {
        id: 16,
        title: "사면 보호공 또는 보강공",
        content: "∙ 모르터 표면의 습윤여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "사면(급경사지)분야",
    tableHeaderCheck: [{ text: "적합" }, { text: "부적합" }, { text: "해당없음" }],
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    footer: "※ 기초 세굴·부등침하 및 주요 구조부의 균열 등 <b>중대 결함</b>이 <b>발견</b> 된 경우 <b>민간전문가</b> 및 <b>점검장비</b>를 활용하여 <b>확인점검</b> 실시",
    list: [
      {
        id: 1,
        title: "경사면내는 안전한가?",
        content: "- 균열 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 2,
        title: "경사면내는 안전한가?",
        content: "- 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 3,
        title: "경사면내는 안전한가?",
        content: "- 융기(배부름) 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 4,
        title: "경사면내는 안전한가?",
        content: "- 수목 전도 없어야 함",
        isChecked: "",
      },
      {
        id: 5,
        title: "경사면내는 안전한가?",
        content: "- 낙석 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 6,
        title: "경사면내는 안전한가?",
        content: "- 뜬 돌 존재 없어야 함",
        isChecked: "",
      },
      {
        id: 7,
        title: "경사면내는 안전한가?",
        content: "- 하단부 침식 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 8,
        title: "경사면내는 안전한가?",
        content: "- 지하수 유출 및 탁수의 용출 없어야 함",
        isChecked: "",
      },
      {
        id: 9,
        title: "경사면내는 안전한가?",
        content: "- 사면 붕괴 이력 및 규모, 위치는 관리하여야 함",
        isChecked: "",
      },
      {
        id: 10,
        title: "경사면내는 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        id: 11,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 균열 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 12,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 13,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 융기(배부름) 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 14,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 낙석 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 15,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 사면 종・횡단배수로가 설치되어야 함",
        isChecked: "",
      },
      {
        id: 16,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 사면 종・횡단배수로 막힘이 없어야 함",
        isChecked: "",
      },
      {
        id: 17,
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        id: 18,
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 평면상 높낮이 차(단차) 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 19,
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 모르터 표면 습윤 없어야 함",
        isChecked: "",
      },
      {
        id: 20,
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 배수공 막힘 등 배수기능 저하 없어야 함",
        isChecked: "",
      },
      {
        id: 21,
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 보호․보강 구조물 파손발생 없어야 함",
        isChecked: "",
      },
      {
        id: 22,
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 소규모 낙석, 붕괴에 의한 보호․보강 효과 저하 없어야 함",
        isChecked: "",
      },
      {
        id: 23,
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "옹벽 분야",
    tableHeaderCheck: [{ text: "적합" }, { text: "부적합" }, { text: "해당없음" }],
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        id: 1,
        title: "옹벽 전면은 안전한가?",
        content: "- 균열이 발생하지 않아야 함",
        isChecked: "",
      },
      {
        id: 2,
        title: "옹벽 전면은 안전한가?",
        content: "- 이음부 이격 없어야 함",
        isChecked: "",
      },
      {
        id: 3,
        title: "옹벽 전면은 안전한가?",
        content: "- 전면부 배부름(돌출) 없어야 함",
        isChecked: "",
      },
      {
        id: 4,
        title: "옹벽 전면은 안전한가?",
        content: "- 주변부 탁한 용수유출 없어야 함",
        isChecked: "",
      },
      {
        id: 5,
        title: "옹벽 전면은 안전한가?",
        content: "- 낙석 없어야 함",
        isChecked: "",
      },
      {
        id: 6,
        title: "옹벽 전면은 안전한가?",
        content: "- 단차, 전도 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 7,
        title: "옹벽 전면은 안전한가?",
        content: "- 배수구 막힘이 없어야 함",
        isChecked: "",
      },
      {
        id: 8,
        title: "옹벽 전면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        id: 9,
        title: "옹벽 배면은 안전한가?",
        content: "- 지반의 균열 및 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        id: 10,
        title: "옹벽 배면은 안전한가?",
        content: "- 배수로의 기능저하 없어야 함",
        isChecked: "",
      },
      {
        id: 11,
        title: "옹벽 배면은 안전한가?",
        content: "- 옹벽 인접 교목 식생(2m이내) 없어야 함",
        isChecked: "",
      },
      {
        id: 12,
        title: "옹벽 배면은 안전한가?",
        content: "- 콘크리트 파손 없어야 함",
        isChecked: "",
      },
      {
        id: 13,
        title: "옹벽 배면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        id: 14,
        title: "옹벽 기초부는 안전한가?",
        content: "- 지반융기가 없어야 함",
        isChecked: "",
      },
      {
        id: 15,
        title: "옹벽 기초부는 안전한가?",
        content: "- 옹벽 침하가 없어야 함",
        isChecked: "",
      },
      {
        id: 16,
        title: "옹벽 기초부는 안전한가?",
        content: "- 주변부 탁한 용수유출이 없어야 함",
        isChecked: "",
      },
      {
        id: 17,
        title: "옹벽 기초부는 안전한가?",
        content: "- 세굴의 발생이 없어야 함",
        isChecked: "",
      },
      {
        id: 18,
        title: "옹벽 기초부는 안전한가?",
        content: "- 기초부 지반활동으로 인한 기울어짐이 없어야 함",
        isChecked: "",
      },
      {
        id: 19,
        title: "옹벽 기초부는 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "제방",
    tableHeaderTitle: "점검사항",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "일반형(토사) - 둑마루", content: "월류", isChecked: "" },
      { id: 2, title: "일반형(토사) - 둑마루", content: "활동", isChecked: "" },
      { id: 3, title: "일반형(토사) - 둑마루", content: "세굴 및 침식", isChecked: "" },
      { id: 4, title: "일반형(토사) - 둑마루", content: "훼손", isChecked: "" },
      { id: 5, title: "일반형(토사) - 비탈면", content: "활동", isChecked: "" },
      { id: 6, title: "일반형(토사) - 비탈면", content: "누수", isChecked: "" },
      { id: 7, title: "일반형(토사) - 비탈면", content: "침하", isChecked: "" },
      { id: 8, title: "일반형(토사) - 비탈면", content: "세굴 및 침식", isChecked: "" },
      { id: 9, title: "일반형(토사) - 비탈면", content: "훼손", isChecked: "" },
      { id: 10, title: "일반형(토사) - 비탈면", content: "동물서식구멍", isChecked: "" },
      { id: 11, title: "일반형(토사) - 비탈면", content: "수목식생", isChecked: "" },
      { id: 12, title: "특수형(구조물) / 옹벽형 육갑문", content: "직립구조물 침하", isChecked: "" },
      { id: 13, title: "특수형(구조물) / 옹벽형 육갑문", content: "기울어짐 / 전도", isChecked: "" },
      { id: 14, title: "특수형(구조물) / 옹벽형 육갑문", content: "기초부 세굴", isChecked: "" },
      { id: 15, title: "특수형(구조물) / 옹벽형 육갑문", content: "구조물 파손", isChecked: "" },
      { id: 16, title: "특수형(구조물) / 옹벽형 육갑문", content: "유수소통 원활", isChecked: "" },
      { id: 17, title: "특수형(구조물) / 옹벽형 육갑문", content: "하도구간내 지장물", isChecked: "" },
      { id: 18, rowType: "textarea", content: "점검자 의견", placeholder: "* 개선 또는 보완이 필요한 사항 등 기술" },
    ],
  },
  {
    title: "지방상수도",
    tableHeaderTitle: "점검사항",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "시설물 안전관리", content: "정수장·배수지·가압장 구조물 균열·침하 여부", isChecked: "" },
      { id: 2, title: "시설물 안전관리", content: "배관 누수 및 노후관 관리 상태", isChecked: "" },
      { id: 3, title: "시설물 안전관리", content: "맨홀·개구부 추락방지시설 설치 여부", isChecked: "" },
      { id: 4, title: "시설물 안전관리", content: "시설물 출입통제 및 잠금장치 상태", isChecked: "" },
      { id: 5, title: "시설물 안전관리", content: "울타리·경고표지 등 안전표지 설치 여부", isChecked: "" },
      { id: 6, title: "전기·기계설비 안전관리", content: "수배전반 이상 여부", isChecked: "" },
      { id: 7, title: "전기·기계설비 안전관리", content: "수중펌프 및 전기시설 누전차단기 정상 작동 여부", isChecked: "" },
      { id: 8, title: "전기·기계설비 안전관리", content: "회전체 기계(모터 등) 방호덮개 설치 및 작동 상태", isChecked: "" },
      { id: 9, title: "전기·기계설비 안전관리", content: "배선 정리 상태(물기 있는 곳 전선 피복 손상 여부 확인)", isChecked: "" },
      { id: 10, title: "전기·기계설비 안전관리", content: "비상발전기 정상 작동 여부", isChecked: "" },
      { id: 11, title: "전기·기계설비 안전관리", content: "전기안전관리자 선임 여부", isChecked: "" },
      { id: 12, title: "밀폐공간 (맨홀, 관로 등)", content: "작업 전 산소 및 유해가스 농도 측정 여부 (기준: 산소 18% 이상 23.5% 미만, 황화수소 10ppm 미만)", isChecked: "" },
      { id: 13, title: "밀폐공간 (맨홀, 관로 등)", content: "환기 장치 상시 가동 여부(밀폐공간 작업 중 강제 환기 실시)", isChecked: "" },
      { id: 14, title: "밀폐공간 (맨홀, 관로 등)", content: "감시인 배치 및 비상 연락망 구축 여부", isChecked: "" },
      { id: 15, title: "밀폐공간 (맨홀, 관로 등)", content: "안전대, 삼각대, 송기마스크 등 구출 장비 비치", isChecked: "" },
      { id: 16, title: "화학약품(응집제, 염소 등)", content: "염소 등 유해화학물질 저장·취급기준 준수 여부", isChecked: "" },
      { id: 17, title: "화학약품(응집제, 염소 등)", content: "MSDS 비치 여부", isChecked: "" },
      { id: 18, title: "화학약품(응집제, 염소 등)", content: "개인보호구 착용 상태(방독마스크, 보호복, 안전장갑 등 착용)", isChecked: "" },
      { id: 19, title: "화학약품(응집제, 염소 등)", content: "비상세척시설 작동 및 응급약품 구비 여부", isChecked: "" },
      { id: 20, title: "화학약품(응집제, 염소 등)", content: "가스누출 감지기 설치 여부", isChecked: "" },
      { id: 21, title: "화학약품(응집제, 염소 등)", content: "환기설비 정상 작동 여부", isChecked: "" },
      { id: 22, title: "일반 안전", content: "작업장 주변 위험 표지판 및 출입금지 구역 설정 여부", isChecked: "" },
      { id: 23, title: "일반 안전", content: "추락 위험 구간(수조 상부 등) 안전난간 및 추락방지망 설치 상태", isChecked: "" },
      { id: 24, title: "일반 안전", content: "소화기 및 비상 대피 경로 확보 여부", isChecked: "" },
      { id: 25, title: "일반 안전", content: "정기 안전교육 실시 여부", isChecked: "" },
      { id: 26, title: "일반 안전", content: "보호구 지급 및 착용 여부", isChecked: "" },
      { id: 27, title: "일반 안전", content: "작업 전 TBM 실시 여부", isChecked: "" },
      { id: 28, title: "일반 안전", content: "단독작업 제한 여부", isChecked: "" },
      { id: 29, title: "일반 안전", content: "위험작업 작업허가제 운영 여부", isChecked: "" },
      { id: 30, rowType: "textarea", content: "점검자 의견", placeholder: "* 개선 또는 보완이 필요한 사항 등 기술" },
    ],
  },
  {
    title: "공공하수처리시설",
    tableHeaderTitle: "점검사항",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "밀폐공간 및 질식 위험", content: "밀폐공간 작업 전 산소 및 유해가스(황화수소, 일산화탄소 등) 농도측정 여부", isChecked: "" },
      { id: 2, title: "밀폐공간 및 질식 위험", content: "작업 중 환기 설비의 정상 가동 여부 및 지속적인 가스 모니터링 실시 여부", isChecked: "" },
      { id: 3, title: "밀폐공간 및 질식 위험", content: "밀폐공간 출입 금지 표지 부착 및 관계자 외 출입 통제 상태", isChecked: "" },
      { id: 4, title: "밀폐공간 및 질식 위험", content: "감시인 배치 및 비상 연락망, 구조용 삼각대, 공기호흡기 등 비상 구난장비 비치 여부", isChecked: "" },
      { id: 5, title: "기계 및 전기·폭발 위험", content: "회전체 기계(블로워, 펌프 등)의 안전 덮개 및 방호울 설치 상태", isChecked: "" },
      { id: 6, title: "기계 및 전기·폭발 위험", content: "전기 판넬 접지 상태 및 누전차단기 정상 작동 여부", isChecked: "" },
      { id: 7, title: "기계 및 전기·폭발 위험", content: "분전반 주변 장애물 적치 여부 및 잠금장치 관리 상태", isChecked: "" },
      { id: 8, title: "기계 및 전기·폭발 위험", content: "감전 위험 지역 내 작업자 방수형 안전모 및 절연장갑 등 보호구 착용 여부", isChecked: "" },
      { id: 9, title: "화학물질 안전관리", content: "화학물질 취급 장소에 물질안전보건자료(MSDS) 비치 및 경고표지 부착 여부", isChecked: "" },
      { id: 10, title: "화학물질 안전관리", content: "유해화학물질 누출 방지를 위한 방류턱(방지턱) 및 배관 연결부 상태 확인", isChecked: "" },
      { id: 11, title: "화학물질 안전관리", content: "약품 주입 펌프 및 저장탱크의 균열, 누출 여부", isChecked: "" },
      { id: 12, title: "화학물질 안전관리", content: "비상시를 대비한 세안설비(샤워기) 및 비상 세척제 정상 작동 여부", isChecked: "" },
      { id: 13, title: "추락 및 일반 안전환경", content: "고소 작업대, 폭기조 상부 등 추락 위험 구간의 안전난간 및 추락방지망 설치 상태", isChecked: "" },
      { id: 14, title: "추락 및 일반 안전환경", content: "작업장 바닥 미끄럼 방지 조치 및 청결 상태 (오일, 슬러지 등)", isChecked: "" },
      { id: 15, title: "추락 및 일반 안전환경", content: "비상 대피 경로 확보 및 유도등, 비상 조명등 점등 상태", isChecked: "" },
      { id: 16, rowType: "textarea", content: "점검자 의견", placeholder: "* 개선 또는 보완이 필요한 사항 등 기술" },
    ],
  },
  {
    title: "소규모수도시설",
    tableHeaderTitle: "점검사항",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "일반환경 및 관리상태", content: "울타리 및 잠금장치: 외부인 출입 제한 및 잠금장치가 견고한가?", isChecked: "" },
      { id: 2, title: "일반환경 및 관리상태", content: "안내 표지판: 관리자 연락처, 시설명, 경고판이 부착되어 있는가?", isChecked: "" },
      { id: 3, title: "일반환경 및 관리상태", content: "주변 환경: 배수지, 취수원 주변에 오염원(쓰레기, 축사 등)은 없는가?", isChecked: "" },
      { id: 4, title: "일반환경 및 관리상태", content: "조명/통풍: 내부 조명이 충분하고, 환기 장치가 작동하는가?", isChecked: "" },
      { id: 5, title: "기계 및 구조물 설비", content: "배수지/물탱크: 균열, 누수, 천장 파손 및 이물질 혼입 가능성은 없는가?", isChecked: "" },
      { id: 6, title: "기계 및 구조물 설비", content: "펌프실: 펌프 진동, 소음, 발열 등 작동 이상 징후는 없는가?", isChecked: "" },
      { id: 7, title: "기계 및 구조물 설비", content: "배관 및 밸브: 연결부 누수, 부식, 밸브 작동 상태는 양호한가?", isChecked: "" },
      { id: 8, title: "기계 및 구조물 설비", content: "사다리 및 난간: 펌프실이나 물탱크 주변 안전난간이 견고한가?", isChecked: "" },
      { id: 9, title: "소독 및 전기 설비", content: "소독 설비: 약품(차아염소산나트륨 등) 잔량이 충분하고 정량 펌프가 작동하는가?", isChecked: "" },
      { id: 10, title: "소독 및 전기 설비", content: "화학물질 관리: 소독제 용기에 라벨이 부착되어 있고, 보관 기준을 준수하는가?", isChecked: "" },
      { id: 11, title: "소독 및 전기 설비", content: "전기 판넬: 누전 차단기 작동 여부, 전선 피복 손상 유무 확인", isChecked: "" },
      { id: 12, title: "소독 및 전기 설비", content: "접지 상태: 모터 등 기계 장치에 접지가 되어 있는가?", isChecked: "" },
      { id: 13, title: "안전 작업 환경", content: "미끄럼 방지: 바닥에 물기가 없거나 미끄럼 방지 조치가 되어 있는가?", isChecked: "" },
      { id: 14, title: "안전 작업 환경", content: "개인보호구: 작업 시 안전모, 안전화, 장갑 등을 착용하는가?", isChecked: "" },
      { id: 15, title: "안전 작업 환경", content: "비상장비: 소화기 비치 및 이상 유무 확인", isChecked: "" },
      { id: 16, title: "수질 및 관리", content: "잔류염소: 적정 잔류염소 농도(0.1~4.0mg/L) 수준을 유지하고 있는가?", isChecked: "" },
      { id: 17, title: "수질 및 관리", content: "정기 검사: 수질 검사 기록이 유지되고 있는가?", isChecked: "" },
      { id: 18, rowType: "textarea", content: "점검자 의견", placeholder: "* 개선 또는 보완이 필요한 사항 등 기술" },
    ],
  },
  {
    title: "약수터",
    tableHeaderTitle: "점검사항",
    tableHeaderCheck: [{ text: "양호" }, { text: "주의" }, { text: "불량" }, { text: "해당없음" }],
    tableHeaderNote: [{ text: "비고(보완계획)", width: "240" }],
    list: [
      { id: 1, title: "수질 및 위생 안전", content: "수질검사 결과 게시: 먹는 물 수질기준(매분기/매월) 검사 결과가 일반인이 보기 쉬운 곳에 게시되어 있는가?", isChecked: "" },
      { id: 2, title: "수질 및 위생 안전", content: "소독 상태: 약수터 물탱크 및 배관 소독이 정기적으로(예: 6개월 1회) 실시되는가?", isChecked: "" },
      { id: 3, title: "수질 및 위생 안전", content: "이물질/오염원: 물받이, 탕정 주변에 이끼, 이물질, 오물 등이 없는가?", isChecked: "" },
      { id: 4, title: "수질 및 위생 안전", content: "음용수 용기: 음용수 용기 세척 시설이 청결하게 유지되는가?", isChecked: "" },
      { id: 5, title: "수질 및 위생 안전", content: "주변 오염원: 약수터 상부 및 주변에 배설물, 쓰레기 등 오염원이 없는가?", isChecked: "" },
      { id: 6, title: "물리적 환경 및 안전", content: "바닥 미끄럼 방지: 약수터 주변 바닥이 물때로 인해 미끄럽지 않으며, 배수가 원활한가?", isChecked: "" },
      { id: 7, title: "물리적 환경 및 안전", content: "접근로 안전: 약수터로 오는 계단이나 경사로가 파손되거나 흔들리지 않는가?", isChecked: "" },
      { id: 8, title: "물리적 환경 및 안전", content: "안전난간 설치: 계단, 경사로, 절벽 인근에 튼튼한 안전난간이 설치되어 있는가?", isChecked: "" },
      { id: 9, title: "물리적 환경 및 안전", content: "조명 상태: 저녁 시간대 이용자를 위한 조명이 작동하는가?", isChecked: "" },
      { id: 10, title: "물리적 환경 및 안전", content: "낙석/붕괴 위험: 주변 비탈면(사면)에 토사 유출이나 낙석 위험은 없는가?", isChecked: "" },
      { id: 11, title: "시설물 상태 관리", content: "배관 파손: 물이 나오는 수도꼭지와 연결된 배관에서 누수가 없는가?", isChecked: "" },
      { id: 12, title: "시설물 상태 관리", content: "구조물 고정: 약수터 구조물(지붕, 기둥, 표지판 등)이 흔들리지 않고 고정되어 있는가?", isChecked: "" },
      { id: 13, title: "시설물 상태 관리", content: "의자 및 편의시설: 주변 벤치, 정자 등이 부서지거나 못이 튀어나와 있지 않은가?", isChecked: "" },
      { id: 14, title: "관리 및 표지판", content: "안내 표지판: 이용자 수칙, 수질검사 결과, 비상연락처 표지판이 잘 보이는가?", isChecked: "" },
      { id: 15, title: "관리 및 표지판", content: "청소 및 관리 기록: 청소 일지(매월 1회 이상)가 비치되어 있는가?", isChecked: "" },
      { id: 16, rowType: "textarea", content: "점검자 의견", placeholder: "* 개선 또는 보완이 필요한 사항 등 기술" },
    ],
  }
];
